import { useState as c, useEffect as p } from "react";
import { useIntersectionObserver as u } from "@partoohub/hooks";
import { extractPartooSubdomain as $, isUrl as k, resizeImage as v } from "@partoohub/utils";
var x = /* @__PURE__ */ ((t) => (t.Initial = "initial", t.Loading = "loading", t.Success = "success", t.Error = "error", t))(x || {});
function F(t, {
  url: r,
  urlMapping: d,
  width: a = 50,
  height: m = 50,
  fit: b = "inside"
}, f = !0) {
  const [n, o] = c(
    "initial"
    /* Initial */
  ), [i, l] = c(""), [g, S] = c(!1), {
    subdomain: s
  } = $();
  return u({
    target: t,
    callback: (e) => S(e.isIntersecting)
  }), p(() => {
    if (!r || typeof r != "string" || !r.trim()) {
      o(
        "error"
        /* Error */
      );
      return;
    }
    const e = s ? `https://static.${s}.partoo.co` : "https://static.partoo.co", I = k(r) ? f ? v({
      url: r,
      urlMapping: d,
      width: a,
      height: m,
      fit: b
    }) : r : `${e}/${r}`;
    l(I);
  }, [r, a, m, f, s]), p(() => {
    if (!g || n !== "initial" || !i.trim()) return;
    o(
      "loading"
      /* Loading */
    );
    const e = new Image();
    e.onload = () => o(
      "success"
      /* Success */
    ), e.onerror = () => o(
      "error"
      /* Error */
    ), e.src = i;
  }, [g, n, i]), {
    state: n,
    originalSrc: r,
    transformedSrc: i
  };
}
export {
  x as ImageStatus,
  F as useImageWithFallback
};
